const ANALYTICS = 'Аналитическая справка'
const STATISTICS = 'Статистическая справка'
const EXPERT_OPINION = 'Экспертное заключение'
const PRIMARY_RESULTS = 'Представление первичных результатов'

export const getSingleReportsList = (isRegMeh: boolean) => {
  const suffix = isRegMeh ? 'РУМ' : 'МУМ'
  const prefix = isRegMeh ? 'reg_' : 'mun_'
  return [
    {
      text: [STATISTICS, suffix].join(' '),
      value: isRegMeh ? 'mun_meh.region_statistics' : 'mun_meh.municipality_statistics',
    },
    {
      text: [EXPERT_OPINION, suffix].join(' '),
      value: `mun_meh.${prefix}expert_opinion`,
    },
    {
      text: [PRIMARY_RESULTS, suffix].join(' '),
      value: `mun_meh.${prefix}primary_results`,
    },
    {
      text: [ANALYTICS, suffix].join(' '),
      value: `mun_meh.${prefix}analytical_ref`,
    },
  ]
}
